var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-error-card',{attrs:{"errorMessage":_vm.isRouteError ? 'This page does not exist.' : _vm.message,"redirectUrl":'/'}})
}
var staticRenderFns = []

export { render, staticRenderFns }